<!-- Menú para dispositivos móviles o el rango de 0px a 860px -->
<nav *ngIf="isHandset$ | async; else tabletDesktopNav">
  <nav class="bg-primary-500 dark:bg-primary-900 shadow-lg shadow-gray-700/50">
    <div class="flex justify-between  pt-8 pb-6 items-center relative">
      <div class="flex items-center">
        <div class="flex flex-col justify-end space-y-8">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More options" class="white-icon-button ml-2">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu" class="mt-1">
            <button mat-menu-item class="btn-mat-menu-edit px-4 py-2">
              <ng-container *ngTemplateOutlet="links; context:{title: 'INICIO', url: 'inicio'}"></ng-container>
            </button>

            <ng-container *ngIf="enlaces$ | async as enlaces">
              <ng-container *ngFor="let enlace of enlaces">
                <button mat-menu-item class="btn-mat-menu-edit px-4 py-2">
                  <ng-container *ngTemplateOutlet="linksCustom; context:{title: enlace.titulo, url: enlace.link}"></ng-container>
                </button>
              </ng-container>
            </ng-container>

            <button mat-menu-item class="btn-mat-menu-edit px-4 py-2">
              <ng-container *ngTemplateOutlet="links; context:{title: 'NOVEDADES', url: 'novedades'}"></ng-container>
            </button>

            <ng-container *ngIf="integration$ | async as integrations">
              <ng-container *ngIf="integrations.length > 0">
                <button mat-menu-item class="btn-mat-menu-edit px-4 py-2">
                  <ng-container *ngTemplateOutlet="links; context:{title: 'CONTACTO', url: 'contacto'}"></ng-container>
                </button>
              </ng-container>
            </ng-container>
          </mat-menu>
        </div>
      </div>
      <div class="flex-1 text-center absolute left-1/2 transform -translate-x-1/2">
        <a routerLink=''>
          <app-logo></app-logo>
        </a>
      </div>
    </div>
  </nav>
</nav>


<!-- Plantillas de enlaces -->
<ng-template #links let-title="title" let-url="url">
  <a class="header-font hover:text-accent-400 text-white tracking-wider" [routerLink]="[url]" routerLinkActive="router-link-active">{{ title }}</a>
</ng-template>

<ng-template #linksCustom let-title="title" let-url="url">
  <a class="header-font hover:text-accent-400 text-white tracking-wider cursor-pointer" (click)="navigateCustomUrl(url)">
    {{ title | uppercase }}
  </a>
</ng-template>


        <!-- Menú en pantallas grandes (tablet y escritorio) -->
<ng-template #tabletDesktopNav>
  <nav class="bg-primary-500 dark:bg-primary-900 shadow-lg shadow-gray-700/50">
    <div class="flex flex-none py-1">
      <div class="flex flex-1 items-center ml-2 mr-4">
        <div class="flex flex-none">
          <a routerLink='' class="ml-4">
            <app-logo></app-logo>
          </a>
        </div>
  
        <div class="flex flex-1 justify-end lg:flex-wrap lg:justify-end lg:space-x-5 mx-2  hidden lg:flex">
          <ng-container *ngTemplateOutlet="links; context:{title: 'INICIO', url: 'inicio'}"></ng-container>
          <ng-container *ngIf="enlaces$ | async as enlaces">
            <ng-container *ngFor="let enlace of enlaces">
              <ng-container *ngTemplateOutlet="linksCustom; context:{title: enlace.titulo, url: enlace.link}"></ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngTemplateOutlet="links; context:{title: 'NOVEDADES', url: 'novedades'}"></ng-container>
          <ng-container *ngIf="integration$ | async as integrations">
            <ng-container *ngIf="integrations.length > 0">
              <ng-container *ngTemplateOutlet="links; context:{title: 'CONTACTO', url: 'contacto'}"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </nav>
</ng-template>
